{
    "Profile_Residents_Resident.residentDetails": "Resident Details",
    "Profile_Residents_Resident.number": "Number",
    "Profile_Residents_Resident.type": "Type",
    "Profile_Residents_Resident.applicant": "Applicant",
    "Profile_Residents_Resident.coApplicant": "Co-Applicant",
    "Profile_Residents_Resident.relationshipToApplicant": "Relationship to Applicant",
    "Profile_Residents_Resident.bankruptcy": "Bankruptcy",
    "Profile_Residents_Resident.yearsContinuouslyInsured": "Years Continuously Insured",
    "Profile_Residents_Resident.yearsInsuredAtCurrentAddress": "Years Insured at Current Address",
    "Profile_Residents_Resident.yearsAtCurrentAddress": "Years At Current Address",
    "Profile_Residents_Resident.numberOfLosses": "Number of Losses",
    "Profile_Residents_Resident.numberOfYearsForLosses": "Number of Years for Losses",
    "Profile_Residents_Resident.lossWithin3Years": "Loss Within 3 Years",
    "Profile_Residents_Resident.previousAddressDetails": "Previous Address Details",
    "Profile_Residents_Resident.locationDetails": "Location Details",
    "Profile_Residents_Resident.name": "Name",
    "Profile_Residents_Resident.person": "Person",
    "Profile_Residents_Resident.criminalConvictions": "Criminal Convictions",
    "Profile_Residents_Resident.claims": "Claims",
    "Profile_Residents_Resident.cancellations": "Cancellations",
    "Profile_Residents_Resident.newCriminalConviction": "New Criminal Conviction",
    "Profile_Residents_Resident.newClaim": "New Claim",
    "Profile_Residents_Resident.newCancellationReason": "New Cancellation Reason",
    "Profile_Residents_Resident.resident": "Resident {number}"
}
